import instance from "../components/general/AxiosInterceptor";

export const loginApi = (data) => {
  return instance.post("/authenticate", data);
};
export const registerMfaApi = (data) => {
  return instance.post("/registerMfa", data);
};
export const sendOtpMailApi = (data) => {
  return instance.post("/sendOtpMail", data);
};
